



























































import Vue from 'vue';
import VueMarkdown from 'vue-markdown';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BottomButton from '@/components/BottomButton.vue';
import { HeroImage, Button, Toast } from '@descomplica/vue-components';
import { getAssetPath } from '@/helpers/assets';
import i18n from '@/i18n';
import { downloadBase64File } from '@/helpers/download';
import accounts from '@/helpers/accountsIframe';
import { EnrollmentStatus } from '@/pipeline/stateMachine';
import { CreditCard } from '@/store/modules/payment/state';

export default Vue.extend({
  components: { PipelineMenuWrapper, VueMarkdown, HeroImage, BottomButton, Button, Toast },
  data() {
    return {
      isLoading: false,
      cookieTokenD: accounts.getTokenD(),
      error: false,
      errorMessage: i18n.t('personalData.genericError'),
      isBankSlipFileLoading: false,
    };
  },
  computed: {
    getCreditCard(): CreditCard {
      return this.$store.getters.getCreditCard;
    },
    backgroundSrc(): string {
      return getAssetPath('img/hero-bg-image.svg');
    },
    imgSrc(): string {
      return getAssetPath('img/result/success.jpg');
    },
    iconSrc(): string {
      return getAssetPath('img/freshman-life-green.svg');
    },
    maskUrl(): string {
      return getAssetPath('img/mask2.svg');
    },
    currentPaymentMethod(): 'bankSlip' | 'creditCard' | 'pix' {
      return this.$store.getters.currentPaymentMethod;
    },
    enrollmentsStatus(): EnrollmentStatus {
      return this.$store.getters.enrollmentStatus;
    },
    isCurrentPaymentMethodBankSlip(): boolean {
      return this.currentPaymentMethod === 'bankSlip' && this.enrollmentsStatus !== 'success';
    },
    studentEmail(): string {
      return this.$store.getters.personalData.email;
    },
    detailsText(): string[] {
      return this.isCurrentPaymentMethodBankSlip
        ? i18n.t('accountsResult.details.bankSlip')
        : i18n.t('accountsResult.details.creditCard');
    },
    bankSlipFile(): string {
      return this.$store.getters.bankSlipFile;
    },
    title(): string {
      return this.isCurrentPaymentMethodBankSlip
        ? i18n.t('accountsResult.titleBankSlip')
        : i18n.t('accountsResult.title');
    },
    bankSlipButtonText(): string {
      return this.isBankSlipFileLoading
        ? i18n.t('accountsResult.loadingBankSlip')
        : i18n.t('accountsResult.downloadBankSlip');
    },
  },
  created() {
    this.isLoading = true;
  },
  async mounted() {
    const didRecurrentCreditCardFail =
      this.getCreditCard.isRecurrentCreditCard && !this.getCreditCard.recurrentCreditCardId;

    if (didRecurrentCreditCardFail) {
      this.error = true;
      this.errorMessage = i18n.t('accountsResult.recurrentCreditCardError');
    }

    this.isLoading = false;
  },
  methods: {
    goToClassrooms(): void {
      const clasroomsUrl: string = process.env.VUE_APP_CLASSROOMS_URL || '/';
      window.location.replace(clasroomsUrl);
    },
    async downloadBankSlipFile() {
      this.isBankSlipFileLoading = true;

      try {
        if (!this.bankSlipFile) await this.$store.dispatch('GENERATE_BANK_SLIP');

        downloadBase64File(this.bankSlipFile, 'boleto-descomplica.pdf', 'application/pdf');
      } finally {
        this.isBankSlipFileLoading = false;
      }
    },

    closeErrorToast() {
      this.error = false;
    },
  },
});
